'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _redux = require('redux');

var _user = require('../actions/user');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_FILTER = {
    state: '全部',
    type: '全部',
    keyword: ''
};
var filter = function filter() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FILTER;
    var action = arguments[1];

    switch (action.type) {
        case _user.FILTER_USERS:
            return Object.assign({}, state, action.filter);
        default:
            return state;
    }
};

var INITIAL_STATE = {
    isFetching: false,
    didInvalidate: false,
    items: [],
    pagination: {}
};
var users = function users() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _user.INVALIDATE_USERS:
            return _extends({}, state, {
                didInvalidate: true
            });
        case _user.REQUEST_USERS:
            return _extends({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case _user.RECEIVE_USERS:
            return _extends({}, state, {
                isFetching: false,
                didInvalidate: false,
                items: action.users,
                lastUpdated: action.received_at,
                pagination: action.pagination
            });
        case _user.FAILURE_USERS:
            return _extends({}, state, {
                isFetching: false,
                error: action.error
            });
        default:
            return state;
    }
};

var userReducer = (0, _redux.combineReducers)({
    users: users,
    filter: filter
});

exports.default = userReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/user.js
// module id = 881
// module chunks = 0